export default __webpack_public_path__ + "static/media/photo-1431578500526-4d9613015464.0c528dc7.jpeg";